<template>
  <nav class="nav-wrapper">      
      <!-- <router-link :to="{ name: 'Home' }"> -->
        <!-- <Logo class="navLogo" /> -->
      <!-- </router-link> -->
    <router-link :to="{ name: 'Dashboard' }">
      <a class="brand-logo left"><img src="../assets/Tweak_Logo_ForWebApp_AllCaps_SVG.svg" alt="Scroll Logo"></a>
    </router-link>
    <!-- <div class="center">
      <button>Create Sheet</button>
    </div> -->
    <ul id="nav-mobile" class="right hide-on-med-and-down">
      <li v-if="user">
        <a class="" @click.prevent="addSheet">Create Sheet</a>
      </li>
      <li>
          <router-link v-if="!user" class="navButton" :to="{ name: 'Login' }">
            Login
          </router-link>
      </li>
      <li>
        <router-link v-if="user" class="navButton" :to="{ name: 'Dashboard' }">
          Dashboard
        </router-link>
      </li>
      <li>
        <a v-if="user" class="navButton" @click="logOut">
          Logout
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import Logo from '@/components/Logo.vue'
import { db } from '@/helpers/firebase'
//import { Timestamp } from '@/helpers/firebase'
import firebase from 'firebase'

export default {
  name: 'NavBar',
  component: Logo,
  computed: {
    //Set the user from our store
    user() {
      return this.$store.getters.getUser
    }
  },
  methods: {
    logOut() {
      this.$firebase.auth().signOut()
      this.$store.dispatch('setUser', '')
      this.$router.push('/login')
    },
    addSheet() {
      db.collection('sheets').add({
        title: '',
        content: '',
        summary: '',
        createdBy: firebase.auth().currentUser.uid,
        dateCreated: firebase.database.ServerValue.TIMESTAMP,
      }).then( (doc) => {
          this.$router.push({ name: 'EditSheet', params: { sheet_id: doc.id } })
      })
    }
  }
}
</script>

<style scoped>
.nav-wrapper {
  padding: 0px 20px;
  background-color: #19A3BF;
}
.brand-logo img {
    height: 64px;
}
.navButton {
  color: #F8F8F8;
}
</style>
